import React from "react";
import { Link } from "react-router-dom";
import { Ripple } from "primereact/ripple";
import { Slide, Fade } from 'react-awesome-reveal';
import Tilt from 'react-parallax-tilt';

import { goToTop } from "../../../WebApp/Components/goToTop";

const NeedHelp: React.FC = () => {
    return (
        <section className="need_help_section section__padding pt-0">
            <article className="need_help_container">
                <div className="container-md">
                    <div className="row">
                        <div className="col-12 col-lg-5 my-auto">
                            <div className="need_help_content">
                                <Slide direction="up" triggerOnce>
                                    <h3 className="need_help_head">Need help?</h3>
                                </Slide>
                                <Slide direction="up" delay={50} triggerOnce>
                                    <p className="need_help_desc">
                                        Need help or have questions? Our dedicated support team is here to assist you at every step. Whether you're getting started or need guidance with any feature, we're just a message away. Reach out to us today, and we'll ensure you have everything you need to succeed.
                                    </p>
                                </Slide>
                                <Slide direction="up" delay={100} triggerOnce>
                                    <div className="section_btn_area justify-content-lg-start">
                                        <Link to={'/contact-us'} className="tdo_button btn_fill p-ripple"
                                            onClick={goToTop}>
                                            Contact Us
                                            <Ripple />
                                        </Link>
                                        <Link to={'/use-case'} className="tdo_button btn_line light p-ripple"
                                            onClick={goToTop}>
                                            Use case
                                            <Ripple />
                                        </Link>
                                    </div>
                                </Slide>
                            </div>
                        </div>

                        <div className="col-12 col-lg-7">
                            <Fade triggerOnce>
                                <Tilt
                                    tiltEnable={false}
                                    scale={1.1}
                                    transitionSpeed={2500}
                                    className="tile_effect">
                                    <div className="need_help_img_content">
                                        <Slide direction="up" triggerOnce>
                                            <img src="/assets/images/website/common/need_help_bg.svg" className="need_help_bg" alt="Need Help" loading="lazy" />
                                        </Slide>
                                        <img src="/assets/images/website/common/need_help_img.webp" className="need_help_img" alt="Need Help" loading="lazy" />
                                    </div>
                                </Tilt>
                            </Fade>
                        </div>
                    </div>
                </div>
            </article>
        </section>
    )
}

export default NeedHelp;